import { render, staticRenderFns } from "./StafferEditDialog.vue?vue&type=template&id=12111fcb&scoped=true&"
import script from "./StafferEditDialog.vue?vue&type=script&lang=js&"
export * from "./StafferEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./StafferEditDialog.vue?vue&type=style&index=0&id=12111fcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12111fcb",
  null
  
)

export default component.exports